module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1 overline"
  }, [_vm._v("\n    Connect to JotForm\n    "), _c('v-spacer'), _vm._v(" "), (_vm.integration && _vm.integration.id) ? _c('v-chip', [(_vm.requests.configure.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "size": "18",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-avatar', [_c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v("\n      Installed\n    ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "label": "Your JotForm API key",
      "hint": "Create a key in JotForm from account settings -> API"
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://jotform.com/myaccount/api",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open Jotform Settings\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.jotform.com/help/253-how-to-create-a-jotform-api-key/",
      "target": "_blank"
    }
  }, [_vm._v("\n          How to create your JotForm API Key\n        ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Important")]), _vm._v(" Make sure you grant \"full access\" to the key you create")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "persistent-hint": "",
      "label": "EU Datacenter",
      "hint": "TIP: If you don't know what this is, leave it as false"
    },
    model: {
      value: (_vm.eu),
      callback: function($$v) {
        _vm.eu = $$v
      },
      expression: "eu"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-card-actions', [(_vm.integration && _vm.integration.id) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmdelete = true
      }
    }
  }, [_vm._v("Uninstall Integration")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.configure.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.configure
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.confirmdelete),
      callback: function($$v) {
        _vm.confirmdelete = $$v
      },
      expression: "confirmdelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Confirm delete this integration\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this integration?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("Uninstall Integration")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-607206aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/InstallJotForm.vue
// module id = 1664
// module chunks = 0